import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { ThemeProvider } from './contexts/ThemeContext';
import { AuthProvider } from './contexts/AuthContext';
import { WebSocketProvider } from './contexts/WebSocketContext';
import { UIStateProvider } from './contexts/UIStateContext';
import { NotificationProvider } from './contexts/NotificationContext';
import ErrorBoundary from './components/ErrorBoundary';
import ToastProvider from './components/ToastProvider';
import NotificationModals from './components/NotificationModals';
import GlobalImportProgressListener from './components/GlobalImportProgressListener';
import ProtectedRoute from './components/ProtectedRoute';
import Landing from './pages/Landing';
import Login from './pages/Login';
import Home from './pages/Home';
import Admin from './pages/Admin';
import Knowledge from './pages/Knowledge';
import Questions from './pages/Questions';
import './App.css';

console.log("VITE_API_BASE =", import.meta.env.VITE_API_BASE);

function AppRoutes() {
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/login" element={<Login />} />
      {/* TEMPORARY: ProtectedRoute disabled for dev */}
      <Route path="/home/:conversationId?" element={<Home />} />
      <Route path="/admin" element={<Admin />} />
      <Route path="/knowledge" element={<Knowledge />} />
      <Route path="/questions" element={<Questions />} />
      {/* <Route
        path="/home"
        element={
          <ProtectedRoute>
            <Home />
          </ProtectedRoute>
        }
      /> */}
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

function App() {
  return (
    <ErrorBoundary>
      <BrowserRouter>
        <ThemeProvider>
          <UIStateProvider>
            <AuthProvider>
              <WebSocketProvider>
                <NotificationProvider>
                  <ToastProvider />
                  <NotificationModals />
                  <GlobalImportProgressListener />
                  <AppRoutes />
                </NotificationProvider>
              </WebSocketProvider>
            </AuthProvider>
          </UIStateProvider>
        </ThemeProvider>
      </BrowserRouter>
    </ErrorBoundary>
  );
}

export default App;
